import { jsonapiModule } from 'jsonapi-vuex'

export default function ({ $axios, store }) {
  const config = { jvtag: '_meta', mergeRecords: true }
  store.registerModule('api', jsonapiModule($axios, config))
}
